export default __webpack_public_path__ + "static/media/6_4_1.151c4a62.png";